import { ActionDescriptor } from '../common/commonTypes';
import DeleteAttributeForm from './DeleteAttributeForm';

const deleteAttribute: ActionDescriptor = {
	FormComponent: DeleteAttributeForm,
	actionTitle: 'Delete',
};

export default deleteAttribute;
